import React from 'react';
import { PropTypes } from 'prop-types';
import numeral from 'numeral';
import { Link } from '../../shared/link';
import { MakeApiCall, WriteConsoleErrors, ReplaceUrl } from '../../shared/utils';
import { ErrorsBlockComponent } from '../../shared/errorsBlockComponent';
import { RefreshButtonComponent } from '../../shared/refreshButtonComponent';
import { InfoItem } from '../AccountInfo/infoitem';
import { DateTimeItem } from '../AccountInfo/datetimeitem';
import { UrlBuilder } from '../../app.defs';
import { PageHeader } from '../../shared/PageHeader';
import { Checkbox } from '../../shared/checkbox';
import { ButtonBusyIndicatorComponent } from '../../shared/buttonBusyIndicatorComponent';
import { BaseFormComponent } from  '../../shared/baseFormComponent';
import { LoadingIndicatorComponent } from '../../shared/loadingIndicatorComponent';

const AFFILIATEINFO_ACTION = {
    NONE: 0,
    LOADING: 1,
    SAVING: 2,
}

class AffiliatePayoutsTable extends React.Component {
    constructor(props, ...others) {
        super(props, ...others);
        this.state = {
            affiliateId: props.affiliateId,
            isLoaded: false,
            isLoading: false,
            errors: null,
            payouts: [],
            requestId: 0,
            pageNum: 1,
            pageSize: props.pageSize,
            totalCount: 0,
        }

        this.doLoad = this.doLoad.bind(this);
    }

    componentDidMount() {
        const self = this;

        self._isMounted = true;
        self.doLoad();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidUpdate(prevProps) {
        const self = this;

        if (self.props.affiliateId != prevProps.affiliateId) {
            self.setState({affiliateId: self.props.affiliateId}, self.doLoad);
        }
        else if(self.props.versionStamp !== prevProps.versionStamp) {
            self.doLoad();
        }
    }

    doLoad() {
        const self = this;
        if (!self._isMounted) {
            return;
        }
        const requestId = self.state.requestId + 1;

        const data = {
            AffiliateId: self.state.affiliateId, 
            pn: self.state.pageNum, 
            ps: self.state.pageSize, 
        };

        new Promise(resolve => {
            self.setState({isLoading: true, errors: null, requestId: requestId}, resolve);
        })
        .then(() => {
            if (self._isMounted) {
                return MakeApiCall(
                    $.get(
                        {
                            url: '/api/admin/getAffiliatePayouts',
                            data: data,
                            dataType: 'json',
                            contentType: "application/json",
                            cache: false
                        }
                    ),
                    false,
                    () => !self._isMounted || (self.state.requestId != requestId)
                )
            }
        })
        .then(response => {
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({
                    isLoading: false,
                    isLoaded: true,
                    payouts: response.Payouts,
                    pageNum: response.PageNum,
                    pageSize: response.PageSize,
                    totalCount: response.TotalCount
                });
            }
        })
        .catch(errors => {
            WriteConsoleErrors(errors, true, false);
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({isLoading: false, errors: errors})
            }
        });
    }

    render() {
        const self = this;
        const {isLoading, isLoaded, errors, pageNum, pageSize, totalCount, payouts} = self.state;
        const {timeZoneId} = self.props;

        const pagesCount = Math.ceil(totalCount / Math.max(pageSize, 1));

        return (
            <div>
                <ErrorsBlockComponent errors={errors} unstyled />
                <div className="fs-xs">Found:&nbsp;{totalCount}</div>
                <table className="affiliatepayoutslist newstyle table-striped-even table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Date</th>
                            <th>Period From</th>
                            <th>Period To</th>
                            <th className="text-right">Commission</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoaded && payouts.map(p => {
                            return (
                                <tr key={p.Id}>
                                    <td className="text-nowrap">
                                        <Link 
                                            to={UrlBuilder.AffiliatePayoutInfo({PayoutId: p.Id})}
                                            className="mre-2"
                                        >
                                            {p.Id}
                                        </Link>
                                    </td>
                                    <td className="text-nowrap"><DateTimeItem utcDate={p.PaidAt} timeZoneId={timeZoneId} /></td>
                                    <td className="text-nowrap"><DateTimeItem utcDate={p.PeriodFrom} /*timeZoneId={timeZoneId}*/ format="L LT" /></td>
                                    <td className="text-nowrap"><DateTimeItem utcDate={p.PeriodTo} /*timeZoneId={timeZoneId}*/ format="L LT" /></td>
                                    <td className="text-nowrap text-right">{numeral(p.Commission).USD('0,0.00')}</td>
                                </tr>
                            )
                        })}
                        {isLoading && !isLoaded && <tr><td colSpan={5}><LoadingIndicatorComponent visible /></td></tr>}
                    </tbody>
                </table>
                {(pagesCount > 1) && 
                    <div className="pt-3">
                        <Pagination 
                            className="justify-content-end"
                            pagesCount={pagesCount}
                            pageNum={pageNum}
                            size="sm"
                            disabled={isLoading}
                            onPageSelect={pn => self.setState({pageNum: pn}, self.doLoad)}
                        />
                    </div>
                }
            </div>
        )
    }
}
AffiliatePayoutsTable.propTypes = {
    pageSize: PropTypes.number.isRequired,
    timeZoneId: PropTypes.string.isRequired,
    affiliateId: PropTypes.number.isRequired
}
AffiliatePayoutsTable.defaultProps = {
    pageSize: 20,
}

export class AffiliateInfoComponent extends BaseFormComponent {
    constructor(props, ...others) {
        super(props, ...others);
        this.state = {
            affiliateId: props.affiliateId,
            isLoaded: false,
            action: AFFILIATEINFO_ACTION.NONE,
            errors: null,
            formData: null,
            _formData: null,
            requestId: 0,
            versionStamp: {},
        }

        this.doLoad = this.doLoad.bind(this);
        this.doSave = this.doSave.bind(this);
        this.doRefresh = this.doRefresh.bind(this);
        this.goToAffiliateId = this.goToAffiliateId.bind(this);
        this.handleSaveClick = this.handleSaveClick.bind(this);
        this.handleRefreshClick = this.handleRefreshClick.bind(this);
    }

    componentDidMount() {
        const self = this;

        self._isMounted = true;
        self.doLoad();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    doRefresh() {
        const self = this;

        if (self._isMounted) {
            self.setState({versionStamp: new Date() * 1}, self.doLoad);
        }
    }

    handleRefreshClick() {
        this.doRefresh();
    }

    doLoad() {
        const self = this;
        if (!self._isMounted) {
            return;
        }
        const requestId = self.state.requestId + 1;

        const data = {AffiliateId: self.state.affiliateId, ListSource: self.props.listSource};

        new Promise(resolve => {
            self.setState({action: AFFILIATEINFO_ACTION.LOADING, errors: null, requestId: requestId}, resolve);
        })
        .then(() => {
            if (self._isMounted) {
                return MakeApiCall(
                    $.get(
                        {
                            url: '/api/admin/getAffiliateInfo',
                            data: data,
                            dataType: 'json',
                            cache: false
                        }
                    ),
                    false,
                    () => !self._isMounted || (self.state.requestId != requestId)
                );
            }
        })
        .then(response => {
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({
                    action: AFFILIATEINFO_ACTION.NONE,
                    isLoaded: true,
                    formData: response,
                    _formData: {...response}
                });
            }
        })
        .catch(errors => {
            WriteConsoleErrors(errors, true, false);
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({action: AFFILIATEINFO_ACTION.NONE, errors: errors});
            }
        });
    }

    goToAffiliateId(affiliateId) {
        const self = this;

        if (self._isMounted) {
            ReplaceUrl(UrlBuilder.AffiliateInfo({AffiliateId: affiliateId, ListSource: self.props.listSource}));
    
            self.setState({affiliateId: affiliateId}, self.doLoad);
        }
    }

    handleSaveClick() {
        this.doSave();
    }

    doSave() {
        const self = this;
        const {formData, requestId} = self.state;

        const data = {
            AffiliateId: formData.Id,
            IsLocked: formData.IsLocked,
            LockReason: formData.LockReason,
            AdminNotes: formData.AdminNotes,
        };

        const verificationToken = formData.VerificationToken;

        new Promise(resolve => {
            self.setState({action: AFFILIATEINFO_ACTION.SAVING, errors: null}, resolve);
        })
        .then(() => {
            if (self._isMounted) {
                return MakeApiCall(
                    $.post(
                        {
                            url: '/api/admin/saveAffiliateInfo',
                            headers: {RequestVerificationToken: verificationToken},
                            data: JSON.stringify(data),
                            contentType: 'application/json',
                            dataType: 'json',
                            cache: false
                        }
                    ),
                    false
                )
            }
        })
        .then(() => {
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.doLoad();
            }
        })
        .catch(errors => {
            WriteConsoleErrors(errors, true, false);
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({action: AFFILIATEINFO_ACTION.NONE, errors: errors});
            }
        });
    }

    render() {
        const self = this;
        const {affiliateId, formData, action, isLoaded, errors, versionStamp} = self.state;
        const {timeZoneId} = self.props;

        const isDisabled = action != AFFILIATEINFO_ACTION.NONE;

        const buttonPrev = Boolean(formData) &&
            <Link 
                key="buttonPrev"
                className="btn btn-outline-secondary btn-sm newstyle" 
                disabled={isDisabled || !Boolean(formData.PrevId)} 
                to={() => self.goToAffiliateId(formData.PrevId)}
            >
                Prev
            </Link>

        const buttonNext = Boolean(formData) &&
            <Link 
                key="buttonNext"
                className="btn btn-outline-secondary btn-sm newstyle" 
                disabled={isDisabled || !Boolean(formData.NextId)} 
                to={() => self.goToAffiliateId(formData.NextId)}
            >
                Next
            </Link>

        const nextPayoutInfo = formData?.NextPayoutInfo;

        return (
            <div>
                <PageHeader
                    fixed
                    captionTruncate
                    notWrappedMaxHeight={75}
                    caption={
                        <h2 className="text-truncate">                                    
                            <span className="mr-2">Affiliate #{affiliateId}</span>
                            <RefreshButtonComponent 
                                disabled={isDisabled} 
                                animated={action == AFFILIATEINFO_ACTION.LOADING} 
                                onClick={self.handleRefreshClick} 
                                className="fs-085"
                            />
                        </h2>
                    }
                    buttons={[<div key="buttonGroup" className="btn-group">{[buttonPrev, buttonNext].filter(Boolean)}</div>]}
                />
                <ErrorsBlockComponent errors={errors} />
                {isLoaded &&
                    <div>
                        <InfoItem 
                            caption="Name" 
                            content={
                                <Link
                                    to={formData.AdminUrl}
                                    disabled={isDisabled}
                                    target="_blank"
                                >
                                    {formData.Name}
                                </Link>
                            } 
                        />
                        <InfoItem caption="Email" content={formData.Email} />
                        <InfoItem caption="Site" content={formData.SiteName} />
                        <InfoItem caption="Created" content={<DateTimeItem utcDate={formData.CreatedAt} timeZoneId={timeZoneId} format="L LTS (z)" />} />
                        <InfoItem caption="Commission percent" content={numeral(formData.CommissionPercent).PERCENT()} />
                        <InfoItem caption="Page views" content={numeral(formData.PageViewsCount).format()} />
                        <InfoItem caption="Visitors" content={numeral(formData.VisitorsCount).format()} />
                        <InfoItem caption="Orders" content={`${numeral(formData.OrdersCount).format()}, Σ ${numeral(formData.OrdersAmount).USD()}`} />
                        <InfoItem 
                            caption="Accrued commission" 
                            content={
                                <>
                                    {(formData.CanceledCommissionAmount > 0) &&
                                        <>
                                            <span>{`${numeral(formData.CommissionAmount + formData.CanceledCommissionAmount).USD()} - `}</span>
                                            <span className="text-danger">{numeral(formData.CanceledCommissionAmount).USD()}</span>
                                            <span>{` = ${numeral(formData.CommissionAmount).USD()}`}</span>
                                        </>
                                    }
                                    {(formData.CanceledCommissionAmount == 0) &&
                                        <span>{numeral(formData.CommissionAmount).USD()}</span>
                                    }
                                </>
                            } 
                        />
                        <InfoItem 
                            caption="Payouts" 
                            content={
                                <div>
                                    <span className="mr-2">{numeral(formData.PayoutAmount).USD()}</span>
                                    <Link
                                        className="fs-sm"
                                        to={UrlBuilder.AffiliatePayoutInfo({PayoutId: 0, AffiliateId: affiliateId})}
                                        disabled={isDisabled}
                                    >
                                        Add payout
                                    </Link>
                                </div>
                            } 
                        />
                        {Boolean(nextPayoutInfo?.Commission) &&
                            <InfoItem 
                                caption="Next payout" 
                                content={
                                    <>
                                        <DateTimeItem utcDate={nextPayoutInfo.PeriodFrom} timeZoneId={timeZoneId} format="L" />
                                        <span className="mx-1">-</span>
                                        <DateTimeItem utcDate={nextPayoutInfo.PeriodTo} timeZoneId={timeZoneId} format="L" />
                                        <span className="mx-2">=</span>
                                        <span className={nextPayoutInfo.Commission < 0 ? 'text-danger' : ''}>{numeral(nextPayoutInfo.Commission).USD()}</span>
                                    </>
                                } 
                            />
                        }
                        <div className="mt-2">
                            <Checkbox
                                name="IsLocked"
                                checked={formData.IsLocked}
                                onChange={self.handleInputChange}
                                label={
                                    <>
                                        <span className="mr-2">Affiliate locked</span>
                                        <span className="fs-xs text-danger">
                                            {Boolean(formData.LockedAt) &&formData.IsLocked && 
                                                <DateTimeItem utcDate={formData.LockedAt} timeZoneId={timeZoneId} format="L LTS (z)" />
                                            }
                                        </span>
                                    </>
                                }
                            />
                            {formData.IsLocked &&
                                <InfoItem 
                                    caption="Lock reason (visible in affiliate page)" 
                                    content={
                                        <textarea 
                                            name="LockReason"
                                            className="form-control compact text-body bg-white" 
                                            rows={4} 
                                            value={formData.LockReason || ''} 
                                            onChange={self.handleInputChange}
                                        />
                                    } 
                                    vertical 
                                />
                            }
                            <InfoItem 
                                caption="Admin notes" 
                                content={
                                    <textarea 
                                        name="AdminNotes"
                                        className="form-control compact text-body bg-white" 
                                        rows={4} 
                                        value={formData.AdminNotes || ''} 
                                        onChange={self.handleInputChange}
                                    />
                                } 
                                vertical 
                            />
                        </div>
                    </div>
                }

                {isLoaded &&
                    <div className="py-4">
                        <button 
                            type="button"
                            className="btn btn-outline-primary btn-sm newstyle"
                            disabled={isDisabled || !self.isChanged()}
                            onClick={self.handleSaveClick}
                        >
                            Save changes
                            <ButtonBusyIndicatorComponent visible={action == AFFILIATEINFO_ACTION.SAVING} />
                        </button>
                    </div>
                }

                {isLoaded &&
                    <div className="pt-3">
                        <ul className="nav nav-tabs" role="tablist">
                            <li className="nav-item">
                                <Link className="nav-link active" data-toggle="tab" to="#payouts">
                                    Payouts
                                </Link>
                            </li>
                        </ul>
                        <div className="tab-content">
                            <div id="connections" className="container tab-pane active p-0">
                                <AffiliatePayoutsTable 
                                    affiliateId={affiliateId}
                                    timeZoneId={timeZoneId}
                                    versionStamp={versionStamp}
                                />
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}
AffiliateInfoComponent.propTypes = {
    affiliateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    timeZoneId: PropTypes.string.isRequired,
    listSource: PropTypes.string,
}